import { render, staticRenderFns } from "./NewInvoiceEntry.vue?vue&type=template&id=a97bb342"
import script from "./NewInvoiceEntry.vue?vue&type=script&lang=js"
export * from "./NewInvoiceEntry.vue?vue&type=script&lang=js"
import style0 from "./NewInvoiceEntry.vue?vue&type=style&index=0&id=a97bb342&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports